
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericOpen as ObiThreewayAcuatorGenericOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-open.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericOpen = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-open',
   elementClass: ObiThreewayAcuatorGenericOpenElement,
   events: {
     
   }
  });
 
 